export default __webpack_public_path__ + "img/calendar.a4931585.svg";